import { request } from './common';

const host = window.configs.IMAGE_HOST;
const fieldKey = 'file';
const COMBINING_MARK_PATTERN = /\p{Mark}/u;

// Client-side guard aligned with the svc-image upload limit.
export const MAX_SVC_IMAGE_UPLOAD_BYTES = 5 * 1024 * 1024;

export type UploadImageResponse =
  | {
      public_id?: string;
      result?: {
        id?: string;
        public_id?: string;
      };
      id?: string;
    }
  | undefined;

export function sanitizeUploadFilename(filename: string) {
  const sanitizedFilename = Array.from(filename.normalize('NFKD'))
    .filter((character) => !COMBINING_MARK_PATTERN.test(character))
    .join('')
    .normalize('NFC')
    .trim();

  return sanitizedFilename || 'upload';
}

export function uploadImage(file, withId?): Promise<UploadImageResponse> {
  const url = withId ? `${host}/${withId}` : host;
  const sanitizedFile = new File([file], sanitizeUploadFilename(file.name), {
    type: file.type,
    lastModified: file.lastModified,
  });

  const formData = new FormData();
  formData.append(fieldKey, sanitizedFile);

  return request(url, {
    method: 'POST',
    body: formData,
  });
}

export function copyImage(id) {
  const formData = new FormData();
  formData.append(fieldKey, `${host}/${id}`);

  return request(host, {
    method: 'POST',
    body: formData,
  });
}

export function getUploadedImageId(response: UploadImageResponse) {
  return response?.public_id || response?.result?.public_id || response?.result?.id || response?.id;
}

export const ALLOWED_IMAGE_MIMETYPES = [
  'image/jpeg',
  'image/jpg',
  'image/pjpeg',
  'image/png',
  'image/svg+xml',
  'image/tiff',
  'image/x-tiff',
  'image/x-tif',
  'image/avif',
  'image/webp',
];

export const ALLOWED_IMAGE_UPLOAD_ACCEPT = [
  ...ALLOWED_IMAGE_MIMETYPES,
  '.jpg',
  '.jpeg',
  '.png',
  '.svg',
  '.tif',
  '.tiff',
  '.avif',
  '.webp',
].join(',');
